const adminSubscriptionsPage = {
  en: {
    adminSubscriptionsPage: {
      loadFailed: "Failed to load subscriptions",
      updated: "Subscription updated",
      updateFailed: "Failed to update subscription",
      adminRequired: "Admin access required",
      subtitle: "Manage user subscriptions and view revenue",
      totalUsers: "Total Users",
      proUsers: "Pro Users",
      enterprise: "Enterprise",
      monthlyRevenue: "Monthly Revenue",
      allSubscriptions: "All Subscriptions",
      user: "User",
      email: "Email",
      currentPlan: "Current Plan",
      apiCalls: "API Calls",
      actions: "Actions",
      unknown: "Unknown",
      plans: { free: "Free", basic: "Basic", pro: "Pro", enterprise: "Enterprise" }
    }
  },
  fr: {
    adminSubscriptionsPage: {
      loadFailed: "Échec du chargement des abonnements",
      updated: "Abonnement mis à jour",
      updateFailed: "Échec de la mise à jour de l'abonnement",
      adminRequired: "Accès administrateur requis",
      subtitle: "Gérez les abonnements des utilisateurs et consultez les revenus",
      totalUsers: "Total des utilisateurs",
      proUsers: "Utilisateurs Pro",
      enterprise: "Entreprise",
      monthlyRevenue: "Revenu mensuel",
      allSubscriptions: "Tous les abonnements",
      user: "Utilisateur",
      email: "E-mail",
      currentPlan: "Plan actuel",
      apiCalls: "Appels API",
      actions: "Actions",
      unknown: "Inconnu",
      plans: { free: "Gratuit", basic: "Basique", pro: "Pro", enterprise: "Entreprise" }
    }
  }
};

export default adminSubscriptionsPage;
